import classes from './bejzbol.module.css'
import { useState, useEffect } from 'react'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'

const Bejzbol = () => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', ''],
      stats: ['', '', '', '', '', ''],
    },
    results: {
      oddsPercentages: ['', ''],
      goals: ['', '', '', ''],
      score: ['', ''],
      betko: [''],
      teamStrengths: ['', '', '', '', '', '', '', ''],
    },
  })

  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const clearFields = () => {
    setData({
      values: {
        odds: ['', ''],
        stats: ['', '', '', '', '', ''],
      },
      results: {
        oddsPercentages: ['', ''],
        goals: ['', '', '', ''],
        score: ['', ''],
        betko: [''],
        teamStrengths: ['', '', '', '', '', '', '', ''],
      },
    })
    setShowInputArea(true)
  }

  const calculateAll = () => {
    const odds = data?.values?.odds || ['', '']
    const sets = data?.values?.goals || ['']
    const setsBoth = data?.values?.stats || ['', '', '', '', '', '']

    const [odd1Str, odd2Str] = odds
    const [setsToWinStr] = sets
    const [wins1Str, losses1Str, played1Str, wins2Str, losses2Str, played2Str] =
      setsBoth
    const odd1 = parseFloat(odd1Str) || 0
    const odd2 = parseFloat(odd2Str) || 0
    const setsToWin = parseInt(setsToWinStr, 10) || 3
    const percent1 = 1 / odd1
    const percent2 = 1 / odd2
    let totalPercent = percent1 + percent2

    totalPercent = totalPercent * 100

    const above100 = totalPercent - 100
    const halfPercent = above100 / 2

    const odd1Percent = parseFloat((percent1 * 100 - halfPercent).toFixed(2))
    const odd2Percent = parseFloat((percent2 * 100 - halfPercent).toFixed(2))

    const wins1 = parseInt(wins1Str, 10) || 0
    const losses1 = parseInt(losses1Str, 10) || 0
    const played1 = parseInt(played1Str, 10) || 0
    const wins2 = parseInt(wins2Str, 10) || 0
    const losses2 = parseInt(losses2Str, 10) || 0
    const played2 = parseInt(played2Str, 10) || 0
    const snd = played1 ? wins1 / played1 : 0
    const sod = played1 ? losses1 / played1 : 0
    const sog = played2 ? wins2 / played2 : 0
    const sng = played2 ? losses2 / played2 : 0
    const sndg = (snd + sng) / 2
    const sodg = (sod + sog) / 2
    const sndsog = (snd + sog) / 2
    const sodsng = (sod + sng) / 2
    console.log(snd, sod, sog, sng, sndg, sodg, sndsog, sodsng)
    const f57 = snd + sod
    const g57 = sog + sng
    const f62 = (f57 + g57) / 2

    const g62 =
      f62 >= 10
        ? 1.23
        : f62 >= 9
        ? 1.34
        : f62 >= 8
        ? 1.11
        : f62 >= 7
        ? 1.21
        : 1.14

    const adjustedG62 = g62 / 100
    const h62 = (g62 + 1.11) / 100

    const f61 = f62 + f62 * adjustedG62 || 0
    const e61 = f61 - f61 * 0.15 || 0

    const bodmin = e61
    const bodbalans = f61
    const g59 = f61 + (f61 - e61)
    const g61 = g59 + g59 * h62 || 0

    const bodmax = g61

    const aj61 = (f61 * Number(odd1Percent)) / 100
    const ak61 = (f61 * Number(odd2Percent)) / 100

    const al61 = Math.round(aj61)
    const an61 = Math.round(ak61)

    const ay61 = al61 === an61 && odd1Percent >= odd2Percent ? al61 + 1 : al61
    const expectedScore1 = Math.round(ay61)

    const ba61 = al61 === an61 && al61 > odd1Percent ? an61 + 1 : an61
    const expectedScore2 = Math.round(ba61)
    const betkoPredlogValue = (e61 + f61) / 2

    setData((prev) => ({
      ...prev,
      results: {
        oddsPercentages: [odd1Percent, odd2Percent],
        goals: [bodmin.toFixed(2), bodbalans.toFixed(2), bodmax.toFixed(2)],
        betko: [betkoPredlogValue.toFixed(2)],
        score: [expectedScore1, expectedScore2],
        teamStrengths: [
          snd.toFixed(2),
          sod.toFixed(2),
          sog.toFixed(2),
          sng.toFixed(2),
          sodg.toFixed(2),
          sndg.toFixed(2),
          sndsog.toFixed(2),
          sodsng.toFixed(2),
        ],
      },
    }))
  }

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  console.log('data', data)

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={`Bejzbol`} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod utakmice
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'odds'}
                labelPrefix={['KI 1', 'KI 2']}
                step={['0.1', '0.1']}
                min={['0.1', '0.1']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
                calculation={calculateAll}
              />

              <div className={classesK.sectionTitle}>
                Upiši br.golova/br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'stats'}
                labelPrefix={[
                  'DOM +  (dom. dao golova)',
                  'DOM - (dom. primio golova)',
                  'DOM BR. (dom. odigrao utakmica)',
                  'GOST +  (gost dao golova)',
                  'GOST-  (gost primio golova)',
                  'GOST BR. (gost odigrao utakmica)',
                ]}
                step={['1', '1', '1', '1', '1', '1']}
                min={['0', '0', '1', '0', '0', '1']}
                type={[
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                setError={setError}
                rows={3}
                calculation={calculateAll}
              />
            </div>
          </>
        )}

        {!showInputArea && (
          <div className={classes.sectionResults}>
            <ResultsSection
              title={'Ishod meča'}
              subtitle={'Konačan ishod'}
              results={data?.results?.oddsPercentages.map(
                (result) => `${result}%`
              )}
              names={['KI 1', 'KI 2']}
              withPercent={true}
            />
            <ResultsSection
              title={'Golovi'}
              subtitle={'Granice golova'}
              results={data?.results?.goals}
              names={[
                'Očekivani minimalni br. golova na utakmici',
                'Očekivani srednji br. golova na utakmici',
                'Očekivani maksimalni br. golova na utakmici',
              ]}
              rows={2}
              breakLastItem={true}
            />
            <ResultsSection
              title={'Tačan rezultat'}
              subtitle={'Opcioni tačan rezultat na utakmici'}
              results={[
                `${data?.results?.score[0]}:${data?.results?.score[1]}`,
              ]}
              names={['Predikcija tačnog rezultata utakmice']}
            />
            <ResultsSection
              title={'Betko predlog'}
              subtitle={'Predlog igre na broj golova'}
              results={data?.results?.betko}
              names={['Predlog prve granice ( + )']}
            />
            <ResultsSection
              title={'Snage timova'}
              subtitle={'Snaga domaćina'}
              results={[
                data?.results?.teamStrengths[0],
                data.results?.teamStrengths[1],
              ]}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snaga gosta'}
              results={[
                data?.results?.teamStrengths[2],
                data.results?.teamStrengths[3],
              ]}
              names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snage oba tima zajedno'}
              results={[
                data?.results?.teamStrengths[4],
                data.results?.teamStrengths[5],
              ]}
              names={[
                'SNDG ( snaga napada domaćina i gosta )',
                'SODG ( snaga odbrane domaćina i gosta )',
              ]}
            />
            <ResultsSection
              subtitle={'Tim / igrač proseci odbrana i napada'}
              results={[
                data?.results?.teamStrengths[6],
                data.results?.teamStrengths[7],
              ]}
              names={[
                'SND + SOG ( dom.daje/gost prima )',
                'SOD + SNG ( dom. prima/gost daje )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Bejzbol
